module.exports = __webpack_public_path__ + "img/logo.b0a7961c.svg";